import { useTranslation } from 'react-i18next';

const userRoles = () => {
	const { t } = useTranslation();

	return [
		{
			key: 'admin',
			label: t('user_roles.admin'),
		},
		{
			key: 'skilled_user',
			label: t('user_roles.skilled_user'),
		},
		{
			key: 'advanced_user',
			label: t('user_roles.advanced_user'),
		},
		{
			key: 'user',
			label: t('user_roles.user'),
		},
	];
};

export default userRoles;
